import { Dialog } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { observer } from 'mobx-react-lite'

export const DialogStack = observer(() => {
  const { dialogStore } = usePlanningStore()

  return (
    <Dialog {...dialogStore.options} onClose={() => dialogStore.close()} fullWidth>
      {dialogStore.view}
    </Dialog>
  )
})
